import { render, staticRenderFns } from "./materialdesign.vue?vue&type=template&id=c9e7490c"
import script from "./materialdesign.vue?vue&type=script&lang=js"
export * from "./materialdesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports